module.exports = __webpack_public_path__ + "img/aeroland-digital-store-product-03.fc35281c.jpg";